/**
 * External Dependencies
 */
import 'jquery';
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.wheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("wheel", handle, { passive: true });
  }
};
jQuery.event.special.mousewheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("mousewheel", handle, { passive: true });
  }
};

import lozad from 'lozad';
const observer = lozad();
observer.observe();

import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox';

import './custom';
import './forms';

// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faImage, faSpinner, faBars, faChevronDown, faCaretLeft, faCaretRight, faShoppingCart, faArrowRight, faTimes, faShare, faChevronLeft, faChevronRight, faPoundSign, faCheck, faQuoteLeft, faQuoteRight, faAt, faSearch, faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin } from '@fortawesome/free-brands-svg-icons';
config.searchPseudoElements=true;
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faSpinner, faImage, faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faShoppingCart, faPinterest, faLinkedin, faChevronDown, faCaretLeft, faCaretRight, faArrowRight, faTimes, faShare, faChevronLeft, faChevronRight, faPoundSign, faCheck, faQuoteLeft, faQuoteRight, faAt, faSearch, faMinus, faPlus );
dom.i2svg();


// vue
window.axios = require('axios')

import Vue from 'vue';
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueProgressBar from 'vue-progressbar'

// views
import Shop from './views/Shop.vue';
import Home from './views/Home';

Vue.component('base-icon', FontAwesomeIcon)

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueProgressBar, {
  color: '#C0363A'
})

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/checkout',
      name: 'index',
      component: Home,
      meta: {
        title: 'Home'
      }
    }
  ]
})

const store = new Vuex.Store({
  state: {
    title: null,
    basket: {},
    countries: {},
    customer: {}
  },
  mutations: {
    title (state, value) {
      state.title = value
    },
    basket (state, object) {
      state.basket = object
    },
    countries (state, object) {
      state.countries = object
    },
    customer (state, object) {
      state.customer = object
    }
  }
})

new Vue({
    el: '#shop',
    router: router,
    store: store,
    components: { Shop }
});


